module.exports = __webpack_public_path__ + "static/media/logo.fa49e8b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 1313
// module chunks = 0